<template>
  <SecondaryVaccinationPage
    title="Chronic Liver Disease"
    :vaccines="vaccinesList"
    prevRoute="/vaccination"
    nextRoute="/vaccination"
    :secondaryImage="require('@/assets/page23/Asset 211.png')"
    :footerBanner1="require('@/assets/page23/Asset 215.png')"
    :footerBanner2="require('@/assets/page4/lowererPanner.png')"
  />
</template>

<script setup>
import SecondaryVaccinationPage from "@/components/SecondaryVaccinationPage.vue";

const vaccinesList = [
  {
    imgPath: require("@/assets/page22/Asset 195.png"),
    name: "Influenza",
    ModalData: {
      Indications: {
        text: "All persons ≥6 months",
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: "One dose every year, preferred before the winter season",
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. </br>
        Precautions: Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 196.png"),
    name: "Pneumococcal",
    ModalData: {
      Indications: {
        text: `Recommended for all adults aged 50 years and older, as well as adults aged 19 to 64 who have specific medical conditions or other risk factors for pneumococcal disease including immunocompromised conditions.`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `A single dose of PCV20 or PCV13/15 followed by a dose of PPSV23 one year later if immunocompetent or ≥8 weeks if immunocompromised. For patients who have previously received one or more doses of PPSV23 only, a single dose of PCV20 or PCV13/15 should be given ≥1 year after the last PPSV23 dose was received. For those who previously received PCV13 only, a single dose of PCV20 should be given ≥1 year after the last PCV13 dose was received.`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction to this vaccine, including (for PCV13) to any diphtheria toxoid-containing vaccine, or to any of its components. </br>
        Precautions: Moderate or severe acute illness.`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 197.png"),
    name: "RSV",
    ModalData: {
      Indications: {
        text: "Adults ≥60 years (IM)",
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: "1 dose",
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 198.png"),
    name: "COVID-19",
    ModalData: {
      Indications: {
        text: `Individuals 12 years and above regardless of previous vaccination. A priority to people with any of the following conditions:<br />
Age over 50 years.<br />
Pregnant women.<br />
Chronic heart, lung, kidney, neurological diseases.<br />
Hereditary blood disorders (sickle cell anemia, thalassemia).<br />
Immunocompromised conditions.<br />
Travelers for Umrah and Hajj.<br />
Healthcare workers with direct patient contact.
`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `1 dose intramuscular, 3 months after the most recent dose.`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 201.png"),
    name: "Zoster",
    ModalData: {
      Indications: {
        text: "Shingrix (RZV) for adults ≥50 years (IM)",
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: "2 doses - Shingrix (RZV) 2nd dose, 2-6 months apart.",
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 202.png"),
    name: "MMR",
    ModalData: {
      Indications: {
        text: `Individuals at higher risk of either exposure or morbidity e.g., Healthcare personnel, college students, Military personnel, international travelers, etc.`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `Individuals at high risk should have two doses separated by at least one month or serologic evidence of immunity.`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Immunocompromising conditions`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 203.png"),
    name: "Varicella",
    ModalData: {
      Indications: {
        text: `All adults without evidence of immunity to varicella`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `2 doses, 2nd dose is given 4—8wks after 1st dose. If 2nd dose is delayed, do not repeat 1st dose, just give 2nd dose.`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Long-term immunosuppressive therapy.</br>
        Precautions: Moderate or severe acute illness.`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 204.png"),
    name: "Tetanus",
    ModalData: {
      Indications: {
        text: `Tdap/Td booster dose every 10 years is recommended for all adult populations. <br />
Tdap is preferred over Td for all booster doses, given the additional coverage.
`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `Single dose of Tdap/Td every 10 years (IM). <br />
Tdap is preferred over Td.
`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction 	
For Tdap only, history of encephalopathy not attributable to an identifiable cause, within 7d following DTP/DTaP, or Tdap`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 206.png"),
    name: "Humanpapilloma",
    ModalData: {
      Indications: {
        text: `For unvaccinated females, 11 through age 26yrs: Complete a 3-dose series of HPV4/9.
Shared clinical decision-making regarding HPV vaccination is recommended for some adults aged 27 through 45 years who are not adequately vaccinated and want to be protected from ongoing risk of acquiring new HPV infection.`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `2-dose series for adolescents who start the vaccination before the 15th birthday (6-12 months apart). 
For individuals 15 years and older, a 3-dose series is recommended on 0, 1-2, 6 months schedule. At least 4wks between 1st and 2nd dose, and at least 12wks between 2nd and 3rd dose.
`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. <br /> Precautions:
Moderate or severe acute illness
Pregnancy(Not recommended).`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 199.png"),
    name: "HepatitisA",
    ModalData: {
      Indications: {
        text: `All adults seeking protection from (HAV) infection and persons with other risk factors.`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: "2 doses schedule with a minimum of 6 months interval",
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. <br /> Precautions :
Moderate or severe acute illness`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 200.png"),
    name: "HepatitisB",
    ModalData: {
      Indications: {
        text: "Recommended if some other risk factor is present (e.g., occupational, lifestyle, or other indications)",
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `3-doses series at 0, 1 and 6 month intervals.`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. <br /> Precautions :
                          Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page22/Asset 205.png"),
    name: "MeningococcalMenB",
    ModalData: {
      Indications: {
        text: `<b> Indications for MenACWY and MenB :</b><br />
Anatomical or functional asplenia (including sickle cell disease and other hemoglobinopathies) <br />
Persistent complement component deficiency<br />
Eculizumab use <br />
Microbiologists routinely exposed to Neisseria meningitidis. <br />
At risk from a meningococcal disease outbreak <br />
<b>Indications for MenACWY:</b><br />
HIV infection<br />
Travel to or live in countries where meningococcal disease is hyperendemic or epidemic, including countries in the African meningitis belt or travel to Makkah, for the Umrah and Hajj<br />
Military recruits<br />
First-year college students<br />
`,
        img: require("@/assets/page23/Asset 212.png"),
      },
      Administration: {
        text: `<b>MenACWY:</b> Administer 1 dose and revaccinate with 1 dose of MenACWY every 5 years, if the risk remains. <br />
<b>MenB:</b> A 2-dose series, 6 months apart.
`,
        img: require("@/assets/page23/Asset 213.png"),
      },
      Contraindications: {
        text: `A severe allergic reaction (for example, anaphylaxis) to a vaccine component or to a prior dose.`,
        img: require("@/assets/page23/Asset 214.png"),
      },
    },
  },
];
</script>
